import { environment } from '@env/environment';

const RECAPTCHA_SCRIPT_ID = 'recaptcha-enterprise-script';
export const E2E_BYPASS_STORAGE_KEY = 'e2e_recaptcha_bypass';

function detectE2EBypass(): void {
  if (environment.production || typeof window === 'undefined') return;
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('e2e') === '1') {
      window.sessionStorage.setItem(E2E_BYPASS_STORAGE_KEY, '1');
    }
  } catch {
    // sessionStorage may be unavailable (privacy mode); bypass simply won't activate
  }
}

export function isE2EBypassActive(): boolean {
  if (environment.production || typeof window === 'undefined') return false;
  try {
    return window.sessionStorage.getItem(E2E_BYPASS_STORAGE_KEY) === '1';
  } catch {
    return false;
  }
}

export function initRecaptcha(): void {
  detectE2EBypass();
  if (typeof document === 'undefined' || !environment.recaptchaSiteKey || isE2EBypassActive()) {
    return;
  }

  // Skip if already injected (e.g. HMR reload)
  if (document.getElementById(RECAPTCHA_SCRIPT_ID)) {
    return;
  }

  // Append the script and return immediately — don't block app bootstrap.
  // RecaptchaService.execute() gates on grecaptcha.enterprise.ready() for readiness.
  const script = document.createElement('script');
  script.id = RECAPTCHA_SCRIPT_ID;
  script.src = `https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(environment.recaptchaSiteKey)}`;
  script.async = true;
  script.onerror = () => console.error('Failed to load reCAPTCHA Enterprise script');
  document.head.appendChild(script);
}
